import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { PatientState } from './states'

const Patient: Module<PatientState, State> = {
  state: new PatientState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default Patient
